export const DEFAULT_SIDEBAR_SPLIT_RATIO = 0.5;
export const MIN_SIDEBAR_SPLIT_RATIO = 0.3;
export const MAX_SIDEBAR_SPLIT_RATIO = 0.7;
export const SIDEBAR_SPLIT_KEYBOARD_STEP = 0.04;

export function clampSidebarSplitRatio(value: number): number {
  if (!Number.isFinite(value)) {
    return DEFAULT_SIDEBAR_SPLIT_RATIO;
  }
  return Math.min(MAX_SIDEBAR_SPLIT_RATIO, Math.max(MIN_SIDEBAR_SPLIT_RATIO, value));
}

export function sidebarSplitRatioFromPointer(input: {
  readonly containerHeight: number;
  readonly currentY: number;
  readonly startRatio: number;
  readonly startY: number;
}): number {
  if (!Number.isFinite(input.containerHeight) || input.containerHeight <= 0) {
    return clampSidebarSplitRatio(input.startRatio);
  }
  return clampSidebarSplitRatio(
    input.startRatio + (input.currentY - input.startY) / input.containerHeight,
  );
}

export function sidebarSplitRatioFromKey(
  ratio: number,
  key: "ArrowDown" | "ArrowUp" | "End" | "Home",
): number {
  switch (key) {
    case "ArrowDown":
      return clampSidebarSplitRatio(ratio + SIDEBAR_SPLIT_KEYBOARD_STEP);
    case "ArrowUp":
      return clampSidebarSplitRatio(ratio - SIDEBAR_SPLIT_KEYBOARD_STEP);
    case "End":
      return MAX_SIDEBAR_SPLIT_RATIO;
    case "Home":
      return MIN_SIDEBAR_SPLIT_RATIO;
  }
}
